// User Repository - OOP Pattern (Repository Pattern)
import { IApiClient } from '../interfaces/IApiClient';
import { IUser } from '../interfaces/IUser';

export interface CreateUserPayload {
  email: string;
  name: string;
  phoneNumber?: string;
  clientId: string;
  damIds?: string[];
  roleIds?: string[];
  roleNames?: string[];
}

export interface UpdateUserPayload {
  name?: string;
  phoneNumber?: string;
  isActive?: boolean;
  damIds?: string[];
  roleIds?: string[];
  roleNames?: string[];
}

export class UserRepository {
  constructor(private apiClient: IApiClient) {}

  async create(data: CreateUserPayload): Promise<IUser> {
    return this.apiClient.post<IUser>('/users', data);
  }

  async getAll(): Promise<IUser[]> {
    return this.apiClient.get<IUser[]>('/users');
  }

  async getById(id: string): Promise<IUser> {
    return this.apiClient.get<IUser>(`/users/${id}`);
  }

  async update(id: string, data: UpdateUserPayload): Promise<IUser> {
    return this.apiClient.put<IUser>(`/users/${id}`, data);
  }

  async resendInvite(id: string): Promise<{ message: string }> {
    return this.apiClient.post<{ message: string }>(`/users/${id}/resend-invite`);
  }

  async delete(id: string): Promise<void> {
    return this.apiClient.delete(`/users/${id}`);
  }
}
